import React, { useState, useEffect } from 'react';
import {
  IconClickable,
  Breadcrumb,
} from '@cochlear-design-system/foundation';

const CustomToolBar = ({ config }) => {
  const { items, defaultSelection } = config;
  const [selectedItem, setSelectedItem] = useState(
    defaultSelection || 'show-all',
  );

  useEffect(() => {
    setSelectedItem(defaultSelection);
  }, [defaultSelection]);

  const itemsLeft = items.filter((item) => item.align !== 'right');

  const renderItem = (item) => {
    const {
      type,
      text,
      icon,
      onHandle,
      sections,
      disabled,
      routerLink,
      analytics,
      isLoading,
    } = item;

    const filterClasses = ['ccl-e-tool-bar__item__filter'];
    if (selectedItem === icon)
      filterClasses.push('ccl-e-tool-bar__item__filter__selected');

    switch (type.toLowerCase()) {
      case 'filter-button':
        return (
          <div className={filterClasses.join(' ')}>
            <IconClickable
              id={icon}
              config={{
                clkContainerCssModifier: 'tool-bar',
                lblContainerCssModifier: 'mobile-hidden',
              }}
              handleClick={() => {
                setSelectedItem(icon);
                onHandle(icon);
              }}
              leftIcon={{
                color: 'interactive',
                size: 'sm',
                type: icon,
              }}
              text={text}
              type={type.toLowerCase()}
              routerLink={routerLink}
              analytics={analytics}
              disabled={disabled}
            />
            {isLoading && (
              <span className="ccl-e-tool-bar__spinner" />
            )}
          </div>
        );

      case 'text-filter-button':
        return (
          <div className={filterClasses.join(' ')}>
            <IconClickable
              id={text}
              clkContainerCssModifier="tool-bar"
              lblContainerCssModifier="inline"
              handleClick={() => {
                setSelectedItem(icon);
                onHandle(icon);
              }}
              text={text}
              type={type.toLowerCase()}
              routerLink={routerLink}
              disabled={disabled}
            />
            {isLoading && (
              <span className="ccl-e-tool-bar__spinner" />
            )}
          </div>
        );

      case 'breadcrumb': {
        const breadcrumbItems = sections.map((section) => ({
          id: '',
          linkTo: '',
          text: section.text,
          handleClick: section.action,
          routerLink,
        }));
        return <Breadcrumb items={breadcrumbItems} />;
      }

      default:
        return null;
    }
  };

  return (
    <div className="ccl-e-tool-bar">
      <div className="ccl-e-tool-bar__left">
        {itemsLeft.map((item) => {
          const itemClasses = ['ccl-e-tool-bar__item'];
          if (item.type === 'breadcrumb') {
            itemClasses.push('ccl-e-tool-bar__item--grow');
          } else {
            itemClasses.push('ccl-e-tool-bar__item--confine');
          }
          return (
            <div
              className={itemClasses.join(' ')}
              key={`tool-bar__item__${item.type}__${item.text}`}
            >
              {renderItem(item)}
            </div>
          );
        })}
      </div>
      <div className="ccl-e-tool-bar__center" />
      <div className="ccl-e-tool-bar__right" />
    </div>
  );
};

export default CustomToolBar;
